import { AbstractControl, ValidatorFn } from '@angular/forms';

export function ConfirmTextValidator(confirmText: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let forbidden = false;
    forbidden = (confirmText === control.value);
    return forbidden ? null : { 'matching': { value: control.value } };
  };
}
